import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '../../core/services/navigation-service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { TextService } from '../../core/services/text-service';

interface StepDefinition {
  id: number;
  labelKey: string;
}

@Component({
  selector: 'app-steps',
  templateUrl: './steps.html',
  styleUrl: './steps.scss',
  standalone: false
})
export class Steps implements OnInit, OnDestroy {
  readonly stepDefs: StepDefinition[] = [
    { id: 1, labelKey: 'step_choose_addon' },
    { id: 2, labelKey: 'step_create_account' },
    { id: 3, labelKey: 'step_account_info' },
    { id: 4, labelKey: 'step_signup_confirmation' },
  ];

  step = 1;
  private sub!: Subscription;

  constructor(
    private router: Router,
    private nav: NavigationService,
    public textService: TextService
  ) {}

  ngOnInit() {
    this.step = this.nav.getCurrentStep();

    this.sub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.step = this.nav.getCurrentStep();
      });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  getStepState(stepId: number): 'completed' | 'active' | 'upcoming' {
    if (stepId < this.step) return 'completed';
    if (stepId === this.step) return 'active';
    return 'upcoming';
  }

  get progressPercent(): number {
    if (this.step <= 1) return 0;
    return ((this.step - 1) / (this.stepDefs.length - 1)) * 100;
  }

  getStepLabel(labelKey: string): string {
    return this.textService.getText(labelKey).replace(/<br\s*\/?>/gi, ' ');
  }
}
